import { UserButton } from "@clerk/react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const initials = (name, email) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length) return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
  return (email || "?")[0].toUpperCase();
};

const BUILT = new Date(process.env.REACT_APP_BUILD_TIME);
const pad = (n) => String(n).padStart(2, "0");
const VERSION = `${BUILT.getUTCFullYear()}.${pad(BUILT.getUTCMonth() + 1)}.${pad(BUILT.getUTCDate())}-${pad(BUILT.getUTCHours())}${pad(BUILT.getUTCMinutes())}`;
const PUBLISHED = BUILT.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });

export const UserMenu = ({ me, roleLabel, showVersion }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex flex-col items-center justify-center leading-none shrink-0 gap-0.5" data-testid="user-menu">
          <UserButton appearance={{ elements: { avatarBox: "w-7 h-7" } }} />
          <span className="text-[10px] font-semibold tracking-wide text-slate-600" data-testid="user-initials">{initials(me?.name, me?.email)}</span>
        </div>
      </TooltipTrigger>
      <TooltipContent side="bottom" align="end" className="text-left" data-testid="user-menu-tooltip">
        <p className="font-semibold text-sm" data-testid="user-full-name">{me?.name || me?.email}</p>
        <p className="text-xs opacity-80" data-testid="user-role">{me?.super_admin ? "Super Admin" : roleLabel}</p>
        {showVersion && <p className="text-[10px] opacity-60 mt-1 pt-1 border-t border-current/20" data-testid="app-version">Version {VERSION} &middot; Published {PUBLISHED}</p>}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
